import { Reveal } from "@/components/site/Reveal";
import { useSiteSettings } from "@/context/SettingsContext";

export const FarmVideo = () => {
  const { settings } = useSiteSettings();
  if (!settings?.farm_video_url) return null;
  return (
    <section id="pull-up-to-the-farm" className="pt-24 sm:pt-28 pb-4" data-testid="farm-video-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="eyebrow text-orange-500">Pull up to the farm</p>
          <h2 className="mt-3 text-3xl sm:text-5xl font-bold tracking-tight" data-testid="farm-video-heading">Pull Up To The Farm</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 rounded-[2rem] p-[2px] bg-gradient-to-br from-emerald-500 via-amber-400 to-purple-500">
            <video src={`${process.env.REACT_APP_BACKEND_URL}${settings.farm_video_url}`} controls playsInline preload="metadata"
              className="w-full rounded-[calc(2rem-2px)] bg-black aspect-video" data-testid="farm-video-player" />
          </div>
          <p className="mt-4 text-center font-display text-lg sm:text-xl font-bold" data-testid="farm-video-caption">Clean grown. Dispensary quality. See it for yourself.</p>
        </Reveal>
      </div>
    </section>
  );
};
